import moment from "moment";

const initialState = {
    list: [],
    detail: null,
    paging: {
      start: 0,
      limit: 10
    },
    sorting: {
      field: 'date',
      type: 'desc'
    },
    filters: {
      point: null,
      points: [],
      payment: null,
      payed: null,
      startDate: new Date(moment().startOf('day')),
      endDate: new Date(moment().endOf('day')),
      id: null
    },
    count: 0
};

export default function invoiceforms(state = initialState, action) {
    switch(action.type) {
      case 'SET_INVOICES': {
            return {
                ...state,
                list: action.list
            };
      }
      case 'SET_INVOICES_FILTERS': {
        return {
            ...state,
            filters: action.filters
        };
      }
      case 'SET_INVOICES_PAGING': {
        return {
            ...state,
            paging: action.paging
        };
      }
      case 'SET_INVOICES_COUNT': {
        return {
            ...state,
            count: action.count
        };
      }
      case 'SET_INVOICE': {
        return {
            ...state,
            detail: action.detail
        };
      }
      default: return state;
      }
  }
